// Author Liang Gangqiang
// Date 2021-07-19 14:15:44

class SithMesQualityInspectType {
constructor({
        id = null,
        parentId = '',
        name = '',
        englishName = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.parentId = parentId;
    this.name = name;
    this.englishName = englishName;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesQualityInspectType();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'parentId',
        label: 'label.sith.quality.sithMesQualityInspectType.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.quality.sithMesQualityInspectType.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.quality.sithMesQualityInspectType.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.sith.quality.sithMesQualityInspectType.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.quality.sithMesQualityInspectType.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectType.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    parentIdFilter : "",
    nameFilter : "",
    englishNameFilter : "",
    seqFilter : "",
    seqGtFilter : "",
    levelFilter : "",
    nodeCodeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.quality.sithMesQualityInspectType.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'englishNameFilter',
        label: 'label.sith.quality.sithMesQualityInspectType.filter.englishName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.quality.sithMesQualityInspectType.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'parentId',
        label: 'label.sith.quality.sithMesQualityInspectType.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'name',
        label: 'label.sith.quality.sithMesQualityInspectType.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'englishName',
        label: 'label.sith.quality.sithMesQualityInspectType.entity.englishName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.quality.sithMesQualityInspectType.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.quality.sithMesQualityInspectType.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesQualityInspectType, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
